export default function ItemWalletUI({
  wallet,title
}) {
  return (
    <div style={styles.wrapper}>
      
      {/* Header */}
      <div style={styles.header}>
        <h2 style={{ margin: 0 }}>📧 {title}</h2>
      </div>

      {/* Wallet Card */}
      <div style={styles.card}>
        <div style={styles.statBox}>
          <span style={styles.label}>Total Credits</span>
          <span style={styles.value}>{wallet.totalCredits}</span>
        </div>

        <div style={styles.statBox}>
          <span style={styles.label}>Used</span>
          <span style={{ ...styles.value, color: "#ff6b6b" }}>
            {wallet.usedCredits}
          </span>
        </div>

        <div style={styles.statBox}>
          <span style={styles.label}>Remaining</span>
          <span style={{ ...styles.value, color: "#2ecc71" }}>
            {wallet.remainingCredits}
          </span>
        </div>
      </div>

    
    </div>
  );
}
const styles = {
  wrapper: {
    padding: 24,
    background: "#f6f8fb",
    
    fontFamily: "Inter, sans-serif"
  },

  header: {
    marginBottom: 20
  },

  card: {
    display: "flex",
    gap: 20,
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 6px 20px rgba(0,0,0,0.05)",
    marginBottom: 20
  },

  statBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  },

  label: {
    fontSize: 13,
    color: "#888"
  },

  value: {
    fontSize: 24,
    fontWeight: 600
  },

  filterCard: {
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 6px 20px rgba(0,0,0,0.05)",
    marginBottom: 20
  },

  sectionTitle: {
    marginBottom: 15
  },

  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12
  },

  input: {
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #ddd",
    fontSize: 14,
    minWidth: 150
  },

  button: {
    padding: "10px 18px",
    borderRadius: 8,
    border: "none",
    background: "#4f46e5",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer"
  },

  tableCard: {
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 6px 20px rgba(0,0,0,0.05)"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse"
  },

  loading: {
    padding: 20
  },

  noData: {
    textAlign: "center",
    padding: 20,
    color: "#999"
  }
};